if(!customElements.get('product-accordion')) {
  customElements.define('product-accordion', class ProductAccoridion extends HTMLElement {
    constructor(){
      super();
      this.toggleListener = (event) => this.toggleAccordion(event);
      this.transitionListener = (event) => this.handleTransitionEnd(event);
    }

    connectedCallback() {
      this.openButton = this.querySelector('[data-open]');
      this.body = this.querySelector('[data-body]');
      if(!this.openButton || !this.body) return;
      this.openButton.addEventListener('click', this.toggleListener);
      this.body.addEventListener('transitionend', this.transitionListener);
      this.syncState();
    }

    disconnectedCallback() {
      if(!this.openButton || !this.body) return;
      this.clearTransition();
      this.openButton.removeEventListener('click', this.toggleListener);
      this.body.removeEventListener('transitionend', this.transitionListener);
    }

    get open() {
      return this.hasAttribute('open');
    }

    get reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    syncState() {
      this.openButton.setAttribute('aria-expanded', this.open ? 'true' : 'false');
      this.body.inert = !this.open;
      this.body.hidden = !this.open;
      this.body.style.height = this.open ? 'auto' : '0px';
    }

    toggleAccordion(event) {
      event.preventDefault();
      this.open ? this.closeAccordion() : this.openAccordion();
    }

    openAccordion() {
      this.clearTransition();
      this.setAttribute('open', '');
      this.openButton.setAttribute('aria-expanded', 'true');
      this.body.hidden = false;
      this.body.inert = false;

      if(this.reducedMotion) {
        this.finishTransition();
        return;
      }

      const currentHeight = this.body.getBoundingClientRect().height;
      this.body.style.height = `${currentHeight}px`;
      this.body.offsetHeight;
      this.animationFrame = requestAnimationFrame(() => {
        this.body.style.height = `${this.body.scrollHeight}px`;
        this.scheduleTransitionEnd();
      });
    }

    closeAccordion() {
      this.clearTransition();
      const currentHeight = this.body.getBoundingClientRect().height;
      this.removeAttribute('open');
      this.openButton.setAttribute('aria-expanded', 'false');
      this.body.inert = true;

      if(this.reducedMotion) {
        this.finishTransition();
        return;
      }

      this.body.style.height = `${currentHeight}px`;
      this.body.offsetHeight;
      this.animationFrame = requestAnimationFrame(() => {
        this.body.style.height = '0px';
        this.scheduleTransitionEnd();
      });
    }

    handleTransitionEnd(event) {
      if(event.target !== this.body || event.propertyName !== 'height') return;
      this.finishTransition();
    }

    scheduleTransitionEnd() {
      const styles = window.getComputedStyle(this.body);
      const durations = styles.transitionDuration.split(',').map(value => this.parseTime(value));
      const delays = styles.transitionDelay.split(',').map(value => this.parseTime(value));
      const duration = Math.max(...durations.map((value, index) => value + (delays[index] || delays[0] || 0)));
      if(duration === 0) {
        this.finishTransition();
        return;
      }
      this.transitionTimer = window.setTimeout(() => this.finishTransition(), duration + 50);
    }

    parseTime(value) {
      const time = parseFloat(value) || 0;
      return value.trim().endsWith('ms') ? time : time * 1000;
    }

    finishTransition() {
      this.clearTransition();
      this.body.style.height = this.open ? 'auto' : '0px';
      this.body.hidden = !this.open;
      this.body.inert = !this.open;
    }

    clearTransition() {
      if(this.animationFrame) cancelAnimationFrame(this.animationFrame);
      if(this.transitionTimer) window.clearTimeout(this.transitionTimer);
      this.animationFrame = null;
      this.transitionTimer = null;
    }
  })
}